import { Component, OnInit, ElementRef, Renderer2, ViewChild, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActionCoCalculatorModel, ActionCoCalculatorMission, ActionCoMissionGroup, ActionCoMissionQuestion, ActionCoMissionPDCGrouped, ActionCoMissionProperty, BObjectModel, ActionCoCollaborateurMission, BObjectBody, PropertyGroup, PropertyData, ActionCoCalculatorTab, Corporation, QueovalItem, ActionCoMissionPDC, TDOPlanDeCharge, QResult, QueovalDik, ActionCoTypeDevis, MainModel, ActionCoBoModel } from '../../models';
import { HttpService, CoreService, QueovalDateService } from '../../services';
import { ToastService } from '../../toast';
import { MissionCalculatorService } from './mission-calculator.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { setAlertMNG } from '../../utilities';
import { map } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';
import { BodisplayService } from '../../bodisplay';
import { BoProperty, IBoProperty } from '../../models/bodisplay/dynamictags-inline/dynamictags-inline.model';
import { of } from 'rxjs/internal/observable/of';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-mission-calculateur',
  templateUrl: './mission-calculator.component.html',
  styleUrls: ['./mission-calculator.component.css']
})

export class CalculatorComponent implements OnInit, OnDestroy {

  public displayMode: string = 'VIEW';

  public missionToDelete: ActionCoCalculatorMission;
  public indexToDelete: number;

  public deleteMission: boolean = false;
  public reinitMission: boolean = false;
  public savingNewObligation: boolean = false;

  public NewObligationLine: ActionCoMissionPDCGrouped = new ActionCoMissionPDCGrouped();

  public fileEvent: any = null;
  public modalImport: NgbModalRef;
  public modalDelete: NgbModalRef;
  public modalReinitialisation: NgbModalRef;
  public modalSaveMission: NgbModalRef;

  public importingConfig: boolean = false;

  public newModelName: string = '';
  public emptyModelName: boolean = false;

  public focusedTab: ActionCoCalculatorMission;
  public focusedTabIndex: number;

  public lastPopoverModelTab: NgbPopover;

  public boModel: BObjectModel;
  //#region props modale conditions
  public showCondition: boolean = false;
  public codeCondition = '';
  public selectedPdc: ActionCoMissionPDCGrouped = new ActionCoMissionPDCGrouped();
  public boDisplayed: string = '';
  public displayBo: boolean = false;
  private modalCoonditionRef: NgbModalRef;

  public codeConditionWithDelay: string = '';
  public isSavingProps: boolean = false;

  // public modelExistingList: Array<QueovalDik>;

  //#endregion

  @ViewChild('ModalImport', { static: false }) ModalImport: ElementRef;
  @ViewChild('ModalConfirmReinitialisation', { static: false }) ModalConfirmReinitialisation: ElementRef;
  @ViewChild('ModalConfirmDeleteMission', { static: false }) ModalConfirmDeleteMission: ElementRef;
  @ViewChild('ModalConditions', { static: false }) ModalConditions: ElementRef;

  @ViewChild('ModalConfirmUpdateMontantMission', { static: false }) ModalConfirmUpdateMontantMission: ElementRef;
  @ViewChild('ModalConfirmUpdateMontantMissionCAC', { static: false }) ModalConfirmUpdateMontantMissionCAC: ElementRef;


  @ViewChild('popoverPlusButton', { static: false }) popoverPlusButton: NgbPopover;

  public isActionCo: boolean = false;
  private idActionCo: string = '0';

  public idMission: string = '0';
  //input obligatoire
  @Input('client') set Setclient(value: string) {
    this.calculatorService.client = new Corporation();
    this.calculatorService.client.Id = value;
  }

  //#region Inputs obligatoires en mode action co
  @Input('idActionCo') set SetIdActionCo(value: string) {
    this.idActionCo = value;
    this.isActionCo = true;
  }
  @Input('typeDevis') typeDevis: ActionCoTypeDevis;
  @Input('status') status: string;
  @Input('isCloture') isCloture: boolean


  //#endregion


  //#region Inputs obligatoires en mode libre
  @Input('relation') relation: string;
  //#endregion

  //#region Inputs optionnel en mode libre
  @Input('idMission') set SetIdMission(value: string) {
    this.idMission = value;
  }
  //#endregion



  @Output() mission: EventEmitter<QueovalDik> = new EventEmitter<QueovalDik>();
  @Output() save: EventEmitter<string> = new EventEmitter<string>();
  constructor(
    protected http: HttpService,
    protected httpClient: HttpClient,
    public indParam: CoreService,
    protected qDateService: QueovalDateService,
    public sanitizer: DomSanitizer,
    public toast: ToastService,
    private renderer: Renderer2,
    protected modalService: NgbModal,
    private router: Router,
    public calculatorService: MissionCalculatorService,
    private cd: ChangeDetectorRef,
    private boService: BodisplayService,
  ) { }

  //#region CYCLE DE VIE
  public ngOnInit(): void {
    this.calculatorService.InitVariables();
    this.calculatorService.bObjectModel.IdDonneePere = this.calculatorService.client.Id;
    if (this.isActionCo) {
      this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/GET_LISTS_MISSIONS_NON_CLOTUREES/${this.calculatorService.client.Id}|${this.idActionCo}|${this.typeDevis}`).subscribe(
        (result: ActionCoCalculatorModel) => {
          let indexLinkedMissions = -1;
          result.Tabs.forEach((tab: ActionCoCalculatorTab) => {
            if (tab.Linked) {
              indexLinkedMissions++;
              this.calculatorService.LinkedMissions.push(this.SetTabToMission(tab));
              this.GetMissionDatas(indexLinkedMissions).subscribe((data) => {
                if (data.index == 0) this.calculatorService.SetDefaultMission();
              });
            } else {
              this.calculatorService.UnlinkedMissions.push(this.SetTabToMission(tab));
            }
          });
        });
    } else {
      this.http.getHttp<MainModel>(`${this.indParam.AppParams.apiUrl}api/main/getData/GET_RELATION_DATA/${this.relation}`).subscribe(
        (result: MainModel) => {
          const tab: ActionCoCalculatorTab = new ActionCoCalculatorTab()
          tab.CodeBo = result.relation.IdBoFils;
          tab.Ident = this.idMission;
          tab.IdRelation = result.relation.Ident;
          tab.TabLabel = result.relation.PereToFils;
          tab.Info = result.relation.Info;
          tab.IsProjet = false;
          tab.Linked = true;
          // this.calculatorService.LinkedMissions.push(this.SetTabToMission(tab));

          this.calculatorService.LinkedMissions.push(this.SetTabToMission(tab));
          this.GetMissionDatas(0).subscribe(() => {
            this.calculatorService.SetDefaultMission();
            // Récupération de la liste des missions existantes (pour les charger)
            this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/GET_LISTS_MISSIONS/${tab.CodeBo}`).subscribe(
              (result: ActionCoCalculatorModel) => {
                this.calculatorService.Mission.BoModels = result.Tabs[0].BoModels;

              });
          });


        });


    }
  }

  public ngOnDestroy(): void {
    (this.modalImport as NgbModalRef | null) = null;
    (this.modalDelete as NgbModalRef | null) = null;
    (this.modalSaveMission as NgbModalRef | null) = null;
  }
  //#endregion
  //#region METHODES PUBLIQUES
  //#region navigation entre les onglets
  public OnChangeMission(mission: ActionCoCalculatorMission, preventChange: boolean) {
    if (!preventChange) {
      if (this.calculatorService.lockTabs) return;

      if (this.displayMode === 'CONFIG' && mission.Groups.length === 0) {
        this.calculatorService.AddGroup(mission);
        mission.Groups[0].Displayed = true;
        mission.Groups[0].Questions[0].Displayed = true;
      }
      this.RefreshGlobalInformationGroupLabel(mission);
      this.calculatorService.OnChangeMission(mission.CodeBo, mission.Ident);
      // this.calculatorService.Mission = mission;
    }
  }

  public OpenModalDeleteMission(mission: ActionCoCalculatorMission, index: number): void {
    if (this.calculatorService.lockTabs) return;
    this.missionToDelete = mission;
    this.indexToDelete = index;
    this.modalDelete = this.modalService.open(this.ModalConfirmDeleteMission, { size: 'q-long', centered: true, windowClass: 'qmodalover' });
  }

  public DeleteMission() {

    this.deleteMission = true;

    //#region Suppression du projet de l'onglet
    if (this.calculatorService.UnlinkedMissions) {
      this.calculatorService.UnlinkedMissions.push(JSON.parse(JSON.stringify(this.missionToDelete)));
    } else {
      this.calculatorService.UnlinkedMissions = [JSON.parse(JSON.stringify(this.missionToDelete))];
    }
    // si l'onglet supprimé est l'onglet actif, l'onglet actif devient l'onget à l'index 0
    if (this.calculatorService.Mission && this.calculatorService.Mission.CodeBo && this.missionToDelete && this.missionToDelete.CodeBo && this.calculatorService.Mission.CodeBo === this.calculatorService.Mission.CodeBo) {
      this.calculatorService.SetDefaultMission();
    }

    this.calculatorService.LinkedMissions.splice(this.indexToDelete, 1);
    //#endregion

    if (this.missionToDelete.Ident && this.missionToDelete.Ident != "0") {
      // Suppression en BDD du projet deja créé
      const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
      model.Mode = 'DELETE_MISSION';
      model.Client = this.calculatorService.client;
      model.Mission.Ident = this.missionToDelete.Ident;

      this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
        (result: ActionCoCalculatorModel) => {
          this.deleteMission = false;
          this.mission.emit(new QueovalDik('DELETE', this.missionToDelete.Ident));
          this.calculatorService.CalculTotalAmount();
          this.modalDelete.close();
          this.displayMode = 'VIEW';
        });
    }
    else {
      this.deleteMission = false;
      this.calculatorService.CalculTotalAmount();
      this.modalDelete.close();
      this.displayMode = 'VIEW';
    }
  }

  public OnAddingTab(mission: ActionCoCalculatorMission, boModel: string, index: number): void {
    if (this.calculatorService.LinkedMissions) {
      this.calculatorService.LinkedMissions.push(mission);
    } else {
      this.calculatorService.LinkedMissions = [mission];
    }
    this.calculatorService.UnlinkedMissions.splice(index, 1);
    this.GetMissionDatas(this.calculatorService.LinkedMissions.length - 1, boModel).subscribe(() => {
      this.OnChangeMission(this.calculatorService.LinkedMissions[this.calculatorService.LinkedMissions.length - 1], false);
    });
  }

  public OnMouseEnterOnUnlinkedTab(popoverModels: NgbPopover, mission: ActionCoCalculatorMission, index: number): void {
    if (this.lastPopoverModelTab && this.focusedTab && this.focusedTab.CodeBo != mission.CodeBo) {
      this.lastPopoverModelTab.close();
    }
    this.focusedTab = mission;
    this.focusedTabIndex = index;
    popoverModels.open();
  }
  //#endregion

  //#region méthodes des boutons d'entête

  public SwitchDisplayMode(): void {

    if (this.displayMode === 'CALCULATE' && this.calculatorService.showCacSaveButton) {
      this.calculatorService.showCacSaveButton = false;
      this.modalSaveMission = this.modalService.open(this.ModalConfirmUpdateMontantMissionCAC, { size: 'q-long', centered: true, windowClass: 'qmodalover' });
    }
    else {
      this.displayMode = this.displayMode === 'CALCULATE' ? 'VIEW' : 'CALCULATE';
      this.RefreshGlobalInformationGroupLabel(this.calculatorService.Mission);
    }
  }

  public DisableCalculate(): boolean {

    if (!this.calculatorService?.Mission?.Ident || this.calculatorService?.Mission?.Ident == '0') {
      if (this.displayMode === 'CALCULATE') {
        this.displayMode = 'VIEW';
        this.RefreshGlobalInformationGroupLabel(this.calculatorService.Mission);
      }
      return true;
    }
    else return false;
  }

  public OnClickConfig(): void {
    if (this.displayMode !== 'CONFIG' && this.calculatorService.Mission.Groups.length === 0) {
      this.calculatorService.AddGroup(this.calculatorService.Mission);
      this.calculatorService.Mission.Groups[0].Displayed = true;
      this.calculatorService.Mission.Groups[0].Questions[0].Displayed = true;
    }
    this.displayMode = this.displayMode === 'CONFIG' ? 'VIEW' : 'CONFIG';
    this.RefreshGlobalInformationGroupLabel(this.calculatorService.Mission);
  }

  public SaveMissionCAC(saveCAC: boolean): void {
    this.modalSaveMission.close();
    if (saveCAC) {
      this.calculatorService.SaveMissionCAC();
      this.mission.emit(new QueovalDik('SAVE', this.calculatorService.Mission.Ident));
    }    
    this.displayMode = this.displayMode === 'CALCULATE' ? 'VIEW' : 'CALCULATE';
    this.RefreshGlobalInformationGroupLabel(this.calculatorService.Mission);
  }

  public OpenModaleSaveMission(): void {
    this.modalSaveMission = this.modalService.open(this.ModalConfirmUpdateMontantMission, { size: 'q-long', centered: true, windowClass: 'qmodalover' });
  }

  public SaveMission(majMontant: boolean): void {
    this.modalSaveMission.close();

    if (!validation(this.calculatorService.Mission, this.toast))
      return;

    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel;
    model.Mission = JSON.parse(JSON.stringify(this.calculatorService.Mission));
    if (!model.Mission)
      model.Mission = new ActionCoCalculatorMission();
    if (!model.Mission.Groups)
      model.Mission.Groups = new Array<ActionCoMissionGroup>();
    model.Mission.Groups.push(JSON.parse(JSON.stringify(this.calculatorService.Mission.globalInformationGroup)));
    model.Client = this.calculatorService.client;
    model.Ident = this.idActionCo;

    this.calculatorService.Mission.loadingDatas = true;
    this.calculatorService.lockTabs = true;

    this.calculatorService.savingMission = true;
    model.SaveMontantMission = majMontant;
    model.Mode = this.displayMode === 'CALCULATE' ? 'UPDATE_MISSIONPDC' : 'SAVE_MISSION'
    this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
      (result: ActionCoCalculatorModel) => {
        this.save.emit(result?.Mission?.Ident);
        this.calculatorService.savingMission = false;
        this.calculatorService.Mission.loadingDatas = false;
        this.calculatorService.lockTabs = false;
        if (!result.HasBlockingAlert) {
          this.AffectGlobalInformationGroup(result);

          if (!result.HasSomeError) {
            result.Mission.CodeBo = this.calculatorService.Mission.CodeBo;
            this.calculatorService.Mission = result.Mission;
            //this.calculatorService.AffectRequiredMissionProperties(this.calculatorService.Mission);
            this.OnChangeMission(this.calculatorService.Mission, false);
            this.mission.emit(new QueovalDik('SAVE', this.calculatorService.Mission.Ident));
          }
        }
        else {
          this.calculatorService.Mission.Ident = result.Mission.Ident;
          this.OnChangeMission(this.calculatorService.Mission, false);
          this.mission.emit(new QueovalDik('SAVE', this.calculatorService.Mission.Ident));
        }
        this.calculatorService.CalculTotalAmount();
      });

    // Méthode de validation des inputs, vérifie que tous les inputs du globalInformationGroup ainsi que les inputs forcé en dur
    // respectent les conditions(require, regex, type, format)
    function validation(pMission: ActionCoCalculatorMission, toast: ToastService): boolean {

      let requiredProps: ActionCoMissionProperty[] = [];
      //#region récupère 'info_pro', 'millepro', 'datedpro', 'datefpro' qui sont les inputs forcés en dur
      for (const grp of pMission.Groups) {
        for (const qst of grp.Questions) {
          for (const prop of qst.Properties) {
            if (prop?.Value?.MainElementList?.length > 0 && ['info_pro', 'millepro', 'datedpro', 'datefpro'].includes(prop.Value.MainElementList[0].ID?.toLocaleLowerCase())) {
              requiredProps.push(prop);
            }
          }
        }
      }
      //#endregion

      //#region concatène le inputs forcés avec les globalInformationGroup
      if (pMission?.globalInformationGroup?.Questions.length > 0 && pMission?.globalInformationGroup?.Questions[0]?.Properties?.length > 0)
        requiredProps = requiredProps.concat(pMission.globalInformationGroup.Questions[0].Properties);
      //#endregion

      const invalidItems: string[] = [];

      //doit contenir l'enemble des inputs forcés à la fin du contrôle
      const forcedProps: ActionCoMissionProperty[] = []
      const lstForcedPropsNotImplemented: string[] = ['info_pro', 'millepro', 'datedpro', 'datefpro'];
      requiredProps.forEach((prop: ActionCoMissionProperty) => {
        if (prop.Value.MainElementList.length > 0) {
          const mainElement = prop.Value.MainElementList[0];
          mainElement.InValid = false;

          const iForcedProp: number = lstForcedPropsNotImplemented.indexOf(mainElement.ID.toLocaleLowerCase());
          //récupère la propriété si c'est une propriété forcée.
          if (iForcedProp > -1) {
            forcedProps.push(prop);
            lstForcedPropsNotImplemented.splice(iForcedProp, 1);
          }

          //#region contrôle que les propriétés obligatoires soient non nulles et respectent leur Regex
          if (mainElement.Required || iForcedProp > -1) {
            //contrôle pour les propriétés qui ne sont pas des combos
            // les combos ne stoquent pas la value mais select l'option correspondant à la valeur choisie
            if (mainElement.TagName !== 'SELECT' && mainElement.TagName !== 'SELECTMOD') {
              switch (mainElement.TagName.toUpperCase()) {
                //se référer à la méthode GetTemplate() du dynamictag.component.ts
                case 'DATEPICKER':
                case 'DATEHOURPICKER':
                case 'CYCLEEL':
                case 'CHECKDAT':
                  mainElement.InValid = mainElement.Value === '' || mainElement.Value === '00/00/0000';
                  break;
                default:
                  mainElement.InValid = mainElement.Value === '';
                  break;
              }
            }
            //contrôle les propriétés de type combo
            else {
              const selOP: QueovalItem[] = mainElement.SelectOptionsList.filter((e: QueovalItem) => e.Selected && (e.Value === '' || e.Value === '-1'));
              mainElement.InValid = selOP.length > 0;
            }
            // la valeur respecte la Regex ?
            if (!mainElement.InValid && mainElement.ValidExp !== '') {
              mainElement.InValid = !new RegExp(mainElement.ValidExp).test(String(mainElement.Value));
            }
          }
          //#endregion
          //#region contrôle que la valeur des propriétés non obligatoires respecte la Regex
          //sur une prop non obligatoire, avec une valeur et une regex non vides
          else if (mainElement.ValidExp !== '' && mainElement.Value !== '') {
            mainElement.InValid = mainElement.InValid || !new RegExp(mainElement.ValidExp).test(String(mainElement.Value));
          }
          //#endregion
          if (mainElement.InValid)
            invalidItems.push(prop.Value.MainLabel.Value);
        }

      });
      let alertMessage: string = '';
      if (invalidItems.length > 0) {
        const alertMsg: string = invalidItems.map(function (e: string): string { return e; }).join(', ');
        alertMessage = `Remplissez les champs suivants avec les données appropriées: <br /> ${alertMsg}.`;
      }
      if (lstForcedPropsNotImplemented.length > 1) {
        if (alertMessage)
          alertMessage += '<br />';
        alertMessage += `Les propriétés ${lstForcedPropsNotImplemented.join(', ')} ne sont pas présentes. modifiez la configuration pour les ajouter au calculateur.`;
      } else if (lstForcedPropsNotImplemented.length > 0) {
        if (alertMessage)
          alertMessage += '<br />';
        alertMessage += `La propriété ${lstForcedPropsNotImplemented[0]} n'est pas présente. modifiez la configuration pour l'ajouter au calculateur.`;
      }
      const propdtD: ActionCoMissionProperty | undefined = forcedProps.find(prop => prop.Value.MainElementList[0].ID.toLocaleLowerCase() == 'datedpro');
      const propdtF: ActionCoMissionProperty | undefined = forcedProps.find(prop => prop.Value.MainElementList[0].ID.toLocaleLowerCase() == 'datefpro');
      if (propdtD && propdtF) {
        const lstDtD: string[] = propdtD.Value.MainElementList[0].Value.split('/');
        const lstDtF: string[] = propdtF.Value.MainElementList[0].Value.split('/');
        const dtD: Date = new Date(Number(lstDtD[2]), Number(lstDtD[1]), Number(lstDtD[0]));
        const dtF: Date = new Date(Number(lstDtF[2]), Number(lstDtF[1]), Number(lstDtF[0]));
        if (dtD.getTime() > dtF.getTime()) {
          propdtD.Value.MainElementList[0].InValid = true;
          propdtF.Value.MainElementList[0].InValid = true;
          if (alertMessage)
            alertMessage += '<br />';
          alertMessage += `La date "${propdtD.Value.MainLabel.Value}" doit être inférieur à la date "${propdtF.Value.MainLabel.Value}"`;
        }
      }
      if (alertMessage)
        toast.showAlertToast(alertMessage);
      return !Boolean(alertMessage);
    }
  }

  public ReinitMission(): void {
    if (this.displayMode === 'CALCULATE' && this.calculatorService.Mission.BoName != 'BO_MCAC') {

      const model: ActionCoCalculatorModel = new ActionCoCalculatorModel(); //JSON.parse(JSON.stringify(this.model));
      model.Mode = "DELETE_MISSIONPDC";
      model.Mission = JSON.parse(JSON.stringify(this.calculatorService.Mission));
      if (!model.Mission)
        model.Mission = new ActionCoCalculatorMission();
      if (!model.Mission.Groups)
        model.Mission.Groups = new Array<ActionCoMissionGroup>();
      model.Mission.Groups.push(JSON.parse(JSON.stringify(this.calculatorService.Mission.globalInformationGroup)));

      model.Client = this.calculatorService.client;
      model.Ident = this.idActionCo;
      this.calculatorService.Mission.loadingDatas = true;
      this.calculatorService.lockTabs = true;

      this.reinitMission = true;

      this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
        (result: ActionCoCalculatorModel) => {
          this.modalReinitialisation.close();
          this.AffectGlobalInformationGroup(result);
          this.reinitMission = false;
          this.calculatorService.Mission.loadingDatas = false;
          this.calculatorService.lockTabs = false;
          if (!result.HasSomeError) {
            result.Mission.CodeBo = this.calculatorService.Mission.CodeBo;
            this.calculatorService.Mission = result.Mission;
            this.OnChangeMission(this.calculatorService.Mission, false);
          }
          this.calculatorService.CalculTotalAmount();
        });
    }
    else {
      this.calculatorService.CalculTotalAmount();
      this.modalReinitialisation.close();
    }
  }

  public ExportConfig(): void {
    this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/EXPORT_DATA_CONFIG/0`).subscribe(
      (result: ActionCoCalculatorModel) => {
        if (!result.HasError && result.StrXml) {
          const filename: string = "configfile.xml";
          const pom: HTMLAnchorElement = document.createElement('a');
          const bb: Blob = new Blob([result.StrXml], { type: 'text/plain' });

          pom.setAttribute('href', window.URL.createObjectURL(bb));
          pom.setAttribute('download', filename);

          pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
          pom.draggable = true;
          pom.classList.add('dragout');

          pom.click();
        }
      });
  }

  public ImportConfig(): void {
    if (!this.fileEvent || !this.fileEvent.target || !this.fileEvent.target.files || this.fileEvent.target.files.length < 1 || this.fileEvent.target.value == '') {
      return;
    }
    const file = this.fileEvent.target.files[0];
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer',
      observe: 'response'
    };
    const formData: FormData = new FormData();

    formData.append('file', file, file.name);
    formData.append('mode', 'SAVE');
    formData.append('token', this.indParam.AppParams.token);
    this.importingConfig = true;
    this.httpClient.post(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/ImportXml/`, formData, config).subscribe(
      (result: any) => {
        this.importingConfig = false;
        //this.loaded = true;
        const res: ActionCoCalculatorModel = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(result.body)));
        if (!res.HasSomeError) {
          (this.modalImport as NgbModalRef).close();
          this.ngOnInit();
        }
        setAlertMNG(this.indParam, this.router, this.toast, res);
      });

  }

  public SaveBoModel(): void {
    if (!this.newModelName) {
      this.emptyModelName = true;
      this.toast.showAlertToast('Veuillez renseigner le nom du modèle');
      return;
    }
    const model: BObjectModel = new BObjectModel();
    model.Body = new BObjectBody();
    model.Body.SelectedGroupsList = new Array<PropertyGroup>();
    const propertiesGroup: PropertyGroup = new PropertyGroup();
    propertiesGroup.DataList = new Array<PropertyData>();
    this.calculatorService.Mission.MissionsProperties.forEach((prop: ActionCoMissionProperty) => {
      propertiesGroup.DataList.push(JSON.parse(JSON.stringify(prop.Value)));
    });
    this.calculatorService.Mission.Groups.forEach((group: ActionCoMissionGroup) => {
      group.Questions.forEach((quest: ActionCoMissionQuestion) => {
        quest.Properties.forEach((prop: ActionCoMissionProperty) => {
          propertiesGroup.DataList.push(JSON.parse(JSON.stringify(prop.Value)));
        });
      });
    });
    this.calculatorService.Mission.globalInformationGroup.Questions.forEach((quest: ActionCoMissionQuestion) => {
      quest.Properties.forEach((prop: ActionCoMissionProperty) => {
        propertiesGroup.DataList.push(JSON.parse(JSON.stringify(prop.Value)));
      });
    });

    model.Body.SelectedGroupsList.push(propertiesGroup);
    model.Mode = 'SAVE_MODEL';
    model.ModelName = this.newModelName;
    model.IdentBO = this.calculatorService.Mission.CodeBo;
    this.indParam.showSplash(true);
    this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, model).subscribe
      ((data: BObjectModel) => {
        if (!data.HasSomeError) {
          this.http.getHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/getData/GET_MODELS/${this.calculatorService.Mission.CodeBo}/`).subscribe
            ((data: BObjectModel) => {
              if (!data.HasSomeError) {
                this.calculatorService.Mission.BoModels = data.Header.SavedModels;
              }
              this.indParam.showSplash(false);
              if (this.popoverPlusButton) {
                this.popoverPlusButton.close();
              }

            });

        } else {
          this.indParam.showSplash(false);
          if (this.popoverPlusButton) {
            this.popoverPlusButton.close();
          }

        }
      });
  }

  public OpenModalImport(e: any): void {
    this.fileEvent = e;
    this.modalImport = this.modalService.open(this.ModalImport, { size: 'q-long', centered: true, windowClass: 'qmodalover' });
    this.modalImport.result.finally(() => {
      this.fileEvent.target.value = '';
    });
  }

  public OpenModalReinitialisation(): void {
    this.modalReinitialisation = this.modalService.open(this.ModalConfirmReinitialisation, { size: 'q-long', centered: true, windowClass: 'qmodalover' });
  }
  //#endregion

  //#endregion

  private RefreshGlobalInformationGroupLabel(mission: ActionCoCalculatorMission): void {
    switch (this.displayMode) {

      case 'CALCULATE':
        mission.globalInformationGroup.Questions[0].Label = 'Nouvelle obligation manuelle';
        mission.globalInformationGroup.Questions[0].Description = '';
        break;
      case 'VIEW':
      case 'CONFIG':
        mission.globalInformationGroup.ShowCalculGroup = mission.globalInformationGroup.Questions[0].Properties.length > 0;
        mission.globalInformationGroup.Questions[0].Label = '';
        mission.globalInformationGroup.Questions[0].Description = '';
        break;
    }
  }

  //#region obligations
  private GetInlinePropertiesDatas(): Observable<QResult<Array<BoProperty<any>>>>[] {
    const tdoObligationBoProperties: Array<string> = [
      TDOPlanDeCharge.Cols.strCodeTache,
      TDOPlanDeCharge.Cols.strLibelTache,
      TDOPlanDeCharge.Cols.strModeCalcul,
      TDOPlanDeCharge.Cols.strDureeUtil,
      TDOPlanDeCharge.Cols.strCodeMission,
      TDOPlanDeCharge.Cols.strCodeRelaColla,
      TDOPlanDeCharge.Cols.dblCoeff,
      TDOPlanDeCharge.Cols.monCoutGlobal,
      TDOPlanDeCharge.Cols.strQuant
    ];

    const tasks: Observable<QResult<Array<IBoProperty<any>>>>[] = [];
    this.selectedPdc.Values.forEach(pdc => {
      tasks.push(this.boService.GetInlinePropertiesDatas('BO_PARAMTASK', tdoObligationBoProperties, pdc.Ident).pipe(map((res) => {
        pdc.BoProperties = res.Value;
        res.Value.forEach(pdcResult => {
          switch (pdcResult.ColumnName) {
            case TDOPlanDeCharge.Cols.strLibelTache:
              pdc.Info = pdcResult.Value;
              break;
            case TDOPlanDeCharge.Cols.strDureeUtil:
              pdc.Duration = pdcResult.Value;
              break;
            case TDOPlanDeCharge.Cols.strQuant:
              pdc.Quantity = pdcResult.Value;
              break;
          }
        });
        return res;
      })));
    });
    return tasks;
  }
  public SaveInlinePropertiesDatas(pdc: ActionCoMissionPDC): void {
    if (this.isSavingProps) {
      this.toast.showInfoToast('Une sauvegarde est déjà en cours');
      return;
    }
    this.isSavingProps = true;
    pdc.BoProperties.forEach(pdcResult => {
      switch (pdcResult.ColumnName) {
        case TDOPlanDeCharge.Cols.strLibelTache:
          pdc.Info = pdcResult.Value;
          break;
        case TDOPlanDeCharge.Cols.strDureeUtil:
          pdc.Duration = pdcResult.Value;
          break;
        case TDOPlanDeCharge.Cols.strQuant:
          pdc.Quantity = pdcResult.Value;
          break;
      }
    });
    this.boService.SaveInlinePropertiesDatas('BO_PARAMTASK', pdc.Ident, pdc.BoProperties).subscribe((res) => {
      if (!res.HasError) {
        if (!res.HasAlert) {
          this.toast.showSuccessToast('Données mises à jour.');
        }
      }
      this.isSavingProps = false;
    });
  }

  public OpenModalCondition(e: any, selectedPdc: ActionCoMissionPDCGrouped) {
    this.codeCondition = selectedPdc.Values[0].Code;
    this.codeConditionWithDelay = this.codeCondition;
    this.selectedPdc = selectedPdc;

    const tasks: Observable<QResult<Array<BoProperty<any>>>>[] = this.GetInlinePropertiesDatas();
    forkJoin(tasks).subscribe(() => {
      selectedPdc.Values.forEach(pdc => { console.table(pdc.BoProperties); });
      this.modalCoonditionRef = this.modalService.open(this.ModalConditions, { size: 'q-xxl', centered: true, windowClass: 'qmodalover' })
      this.modalCoonditionRef.result.finally(() => { this.ToogleBoObligation('') });
      setTimeout(() => { this.showCondition = true; }, 1);
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
    });
  }


  public ToogleConfigObligations(): void {
    this.calculatorService.displayConfigObligationButtons = !this.calculatorService.displayConfigObligationButtons;
  }


  public ToogleBoObligation(pIdBo: string): void {
    this.displayBo = false;
    this.cd.detectChanges();
    setTimeout(() => {
      if (pIdBo) {
        this.http.getHttp<ActionCoBoModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Bo/GET_BO/BO_PARAMTASK|REL_BO_PAR_BO_PARAMTASK|1|${pIdBo}/`).subscribe(
          (result: ActionCoBoModel) => {
            this.boModel = new BObjectModel();
            this.boModel.IdDonneeFils = result.BusinessObject.IdDonneeFils;
            this.boModel.IdDonneePere = result.BusinessObject.IdDonneePere;
            this.boModel.IdentBO = result.BusinessObject.IdentBo;
            this.boModel.IdRelation = result.BusinessObject.IdRelation;
            this.boModel.ShowSaveButton = true;
            this.displayBo = true;
          });
      } else {
        this.displayBo = false;
      }

    });
    this.boDisplayed = pIdBo;
  }

  public OnCloseBoObligation(bo: BObjectModel | null): void {
    if (bo != null && bo.IdDonneeFils && bo.IdDonneeFils != '0') {
      this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/GET_OBLIGATION_PROPERTY/${bo.IdDonneeFils}`).subscribe(
        (result: ActionCoCalculatorModel) => {

          //#region construction de l'objet obligation se basant sur celle sélectionnée mais en affectant les nouvelles valeurs
          const obligation: ActionCoMissionPDCGrouped = JSON.parse(JSON.stringify(this.selectedPdc));
          obligation.Code = result.Obligations[0].Code;
          const value: ActionCoMissionPDC = new ActionCoMissionPDC();
          value.Code = result.Obligations[0].Values[0].Code;
          value.Date = result.Obligations[0].Values[0].Date;
          value.Days = result.Obligations[0].Values[0].Days;
          value.Duration = result.Obligations[0].Values[0].Duration;
          value.Frequency = result.Obligations[0].Values[0].Frequency;
          value.Ident = result.Obligations[0].Values[0].Ident;
          value.Info = result.Obligations[0].Values[0].Info;
          value.Quantity = result.Obligations[0].Values[0].Quantity;
          obligation.Values = [value];
          //#endregion

          //#region indexs à partir du code AVANT modification du Bo
          let pdcExistedBefore: boolean = false;
          let pdcHasMoved: boolean = false;
          let codeAffectedToQuestionBefore: boolean = false;
          let beforeIGroup = -1;
          let beforeIQuestion = -1;
          let beforeIObligation = this.calculatorService.Mission.ObligationsProperties.findIndex(obli => obli.Code == this.selectedPdc.Code);
          let beforeIObliPdcValue: number = -1;
          //#endregion

          //#region indexs à partir du code APRES modification du Bo
          let PdcExist: boolean = false;
          let codeAffectedToQuestion: boolean = false;
          let iGroup = -1;
          let iQuestion = -1;
          let iObligation = this.calculatorService.Mission.ObligationsProperties.findIndex(obli => obli.Code == result.Obligations[0].Code);
          let iObliPdcValue: number = -1;
          //#endregion

          let canBreak: boolean[] = [false, false];
          //#region récupération des indexes dans les obligations des questions des groupes (uniquement si l'obligation avant ou apres modif du Bo est rattachée à une question)
          if (iObligation > -1) {
            iObliPdcValue = this.calculatorService.Mission.ObligationsProperties[iObligation].Values.findIndex(value => value.Ident == result.Obligations[0].Values[0].Ident);
            canBreak[0] = true;
          }
          if (beforeIObligation > -1) {
            beforeIObliPdcValue = this.calculatorService.Mission.ObligationsProperties[beforeIObligation].Values.findIndex(value => value.Ident == result.Obligations[0].Values[0].Ident);
            canBreak[1] = true;
          }
          //pour chaque obligation de chaque question de chaque groupe de la mission en cours
          for (let g: number = 0; g < this.calculatorService.Mission.Groups.length; g++) {
            for (let q: number = 0; q < this.calculatorService.Mission.Groups[g].Questions.length; q++) {
              for (let o: number = 0; o < this.calculatorService.Mission.Groups[g].Questions[q].Obligations.length; o++) {

                // si la nouvelle obligation possède le même code obligation que l'obligation de la boucle on récupère sa position.
                if (iObligation == -1 && this.calculatorService.Mission.Groups[g].Questions[q].Obligations[o].Code == result.Obligations[0].Code) {
                  iGroup = g;
                  iQuestion = q;
                  iObligation = o
                  canBreak[0] = true;
                  codeAffectedToQuestion = true;
                  iObliPdcValue = this.calculatorService.Mission.Groups[g].Questions[q].Obligations[0].Values.findIndex(value => value.Ident == result.Obligations[0].Values[0].Ident);
                  break;
                }

                // si l'obligation AVANT la sauvegarde possédait le même code obligation que l'obligation de la boucle on récupère sa position.
                if (beforeIObligation == -1 && this.calculatorService.Mission.Groups[g].Questions[q].Obligations[o].Code == this.selectedPdc.Code) {
                  beforeIGroup = g;
                  beforeIQuestion = q;
                  beforeIObligation = o
                  canBreak[1] = true;
                  codeAffectedToQuestionBefore = true;
                  beforeIObliPdcValue = this.calculatorService.Mission.Groups[g].Questions[q].Obligations[0].Values.findIndex(value => value.Ident == this.selectedPdc.Values[0].Ident);
                  break;
                }
                // lorsque les deux positions sont récupérées on sort.
                if (canBreak[0] && canBreak[1]) break;
              }
              if (canBreak[0] && canBreak[1]) break;
            }
            if (canBreak[0] && canBreak[1]) break;
          }

          PdcExist = iObliPdcValue > -1;
          pdcExistedBefore = beforeIObliPdcValue > -1;
          pdcHasMoved = beforeIGroup != iGroup || beforeIQuestion != iQuestion || beforeIObligation != iObligation || beforeIObliPdcValue != iObliPdcValue
          //#endregion


          const iSelectedPdcValue: number = this.selectedPdc.Values.findIndex((pdc: ActionCoMissionPDC) => pdc.Ident == result.Obligations[0].Values[0].Ident);
          //affectation de l'obligation 
          if (iSelectedPdcValue > -1) {
            this.selectedPdc.Values[iSelectedPdcValue] = obligation.Values[0];
          }

          if (pdcExistedBefore && pdcHasMoved) {
            if (codeAffectedToQuestionBefore) {
              // suppression de l'obligation dans le groupe d'obligations de la question.
              this.calculatorService.Mission.Groups[beforeIGroup].Questions[beforeIQuestion].Obligations[beforeIObligation].Values.splice(beforeIObliPdcValue, 1);
              if (this.calculatorService.Mission.Groups[beforeIGroup].Questions[beforeIQuestion].Obligations[beforeIObligation].Values.length == 0) {
                this.calculatorService.Mission.Groups[beforeIGroup].Questions[beforeIQuestion].Obligations.splice(beforeIObligation, 1);
              }
            } else {
              // suppression de l'obligation dans les groupe d'obligations non rattachés aux questions.
              this.calculatorService.Mission.ObligationsProperties[beforeIObligation].Values.splice(beforeIObliPdcValue, 1);
              if (this.calculatorService.Mission.ObligationsProperties[beforeIObligation].Values.length == 0) {
                this.calculatorService.Mission.ObligationsProperties.splice(beforeIObligation, 1);
              }
            }
            //rafraichit le pipe et l'affichage.
            this.calculatorService.Mission.ObligationsProperties = [...this.calculatorService.Mission.ObligationsProperties];
          }

          if (!PdcExist || (pdcExistedBefore && pdcHasMoved)) {
            if (codeAffectedToQuestion) {
              //ajout de l'obligation dans le groupe existant rattaché à la question.
              this.calculatorService.Mission.Groups[iGroup].Questions[iQuestion].Obligations[iObligation].Values.push(obligation.Values[0]);
            }
            else if (iObligation > -1) {
              //ajout de l'obligation dans le groupe existant non rattaché à une question.
              this.calculatorService.Mission.ObligationsProperties[iObligation].Values.push(obligation.Values[0]);
            } else {
              //ajout de l'obligation dans un nouveau groupe non rattaché à une question.
              this.calculatorService.Mission.ObligationsProperties.push(obligation);
            }
            //l'obligation est la même que avant la sauvegarde du Bo ou 
          } else {
            if (codeAffectedToQuestion) {
              //modification de l'obligation située dans une question
              this.calculatorService.Mission.Groups[iGroup].Questions[iQuestion].Obligations[iObligation].Values[iObliPdcValue] = obligation.Values[0];
            } else {
              //modification de l'obligation non rattachée à une question
              this.calculatorService.Mission.ObligationsProperties[iObligation].Values[iObliPdcValue] = obligation.Values[0];
            }
          }
          const tasks: Observable<QResult<Array<BoProperty<any>>>>[] = this.GetInlinePropertiesDatas();
          forkJoin(tasks).subscribe();
          this.cd.detectChanges();
        });
    }
    this.ToogleBoObligation('');
  }

  public DelayCodeCondition(pCode: string): void {
    setTimeout(() => { this.codeConditionWithDelay = pCode; }, 500);
  }

  public LoadModel(boModel: string): void {
    this.GetMissionDatas(0, boModel).subscribe(() => {
      this.OnChangeMission(this.calculatorService.LinkedMissions[0], false);
    });
  }

  //#endregion

  public emitMission(value: QueovalDik) {
    this.mission.emit(value);
  }

  private SetTabToMission(tab: ActionCoCalculatorTab): ActionCoCalculatorMission {
    const result: ActionCoCalculatorMission = new ActionCoCalculatorMission();
    result.TabLabel = tab.TabLabel;
    result.CodeBo = tab.CodeBo;
    result.Ident = tab.Ident;
    result.IdRelation = tab.IdRelation;
    result.Info = tab.Info;
    result.IsProjet = tab.IsProjet;
    result.BoModels = tab.BoModels;
    result.SelectedBoModel = tab.SelectedBoModel;
    result.Linked = tab.Linked;
    return result;
  }

  private GetMissionDatas(index: number, boModel: string = ''): Observable<{ mission: ActionCoCalculatorModel, index: number }> {
    this.calculatorService.LinkedMissions[index].loadingDatas = true;
    this.calculatorService.lockTabs = true;
    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
    model.Mode = 'GET_MISSION';
    model.Mission = this.calculatorService.LinkedMissions[index];
    model.Client = new Corporation();
    model.Client.Id = this.calculatorService.client.Id;
    model.Mission.SelectedBoModel = boModel;
    return this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).pipe(
      map((result: ActionCoCalculatorModel) => {
        this.AffectGlobalInformationGroup(result);
        this.calculatorService.Collaborateurs = result.Collaborateurs;
        this.calculatorService.LinkedMissions[index].loadingDatas = false;
        this.calculatorService.lockTabs = false;
        this.calculatorService.Amount += result.Mission.Amount;
        this.calculatorService.Discount += result.Mission.Discount;
        this.calculatorService.Mission = result.Mission;
        //this.calculatorService.AffectRequiredMissionProperties(this.calculatorService.LinkedMissions[index]);
        return { mission: result, index: index };
      }))
  }

  private AffectGlobalInformationGroup(calculator: ActionCoCalculatorModel): ActionCoCalculatorModel {
    let result: ActionCoCalculatorModel = calculator;

    if (!result.Mission.globalInformationGroup)
      result.Mission.globalInformationGroup = new ActionCoMissionGroup();
    result.Mission.globalInformationGroup.Label = 'Informations Générales';
    result.Mission.globalInformationGroup.Description = 'Liste des propriétés obligatoires';
    result.Mission.globalInformationGroup.Visible = true;
    result.Mission.globalInformationGroup.Questions = new Array<ActionCoMissionQuestion>();
    const question = new ActionCoMissionQuestion();
    question.Label = '';
    question.ShowCalculQuestion = true;
    question.Description = '';
    result.Mission.globalInformationGroup.Questions.push(JSON.parse(JSON.stringify(question)));
    question.Label = 'Obligations manuelles';
    question.Description = 'Obligations générées manuellement';
    result.Mission.globalInformationGroup.Questions.push(JSON.parse(JSON.stringify(question)));
    question.Label = 'Obligations automatiques';
    question.Description = 'Obligations générées depuis le plan de charge mais non rattachées à une question';
    result.Mission.globalInformationGroup.Questions.push(JSON.parse(JSON.stringify(question)));

    if (result && result.Obligations) {
      result.Mission.globalInformationGroup.Questions[1].Obligations = new Array<ActionCoMissionPDCGrouped>();
      result.Mission.globalInformationGroup.Questions[2].Obligations = new Array<ActionCoMissionPDCGrouped>();
      result.Obligations.forEach((obligation: ActionCoMissionPDCGrouped) => {
        if (obligation.Code.startsWith('X-')) {
          obligation.isPdc = true;
          (obligation as any).Deletable = true;
          result.Mission.globalInformationGroup.Questions[1].Obligations.push(obligation);
          result.Mission.globalInformationGroup.Questions[1].Amount += obligation.Amount;
        } else {
          result.Mission.globalInformationGroup.Questions[2].Obligations.push(obligation);
          result.Mission.globalInformationGroup.Questions[2].Amount += obligation.Amount;
        }
        result.Mission.globalInformationGroup.Questions[0].Amount += obligation.Amount;
      });
    }
    return result;
  }
}
